module.exports = __webpack_public_path__ + "static/media/favicon.bcc25854.png";


//////////////////
// WEBPACK FOOTER
// ./src/files/favicon.png
// module id = 1388
// module chunks = 0